export const normalizeGuideSteps = (content: string): string => {
  return content.replace(/(^|\n)(\d+)\s*\n/g, (_, prefix, n) => `${prefix}Paso ${n}: `)
}

export const isGuideMessage = (content: string): boolean => {
  const normalized = normalizeGuideSteps(content)
  return normalized.includes('Paso 1:') || normalized.includes('Paso 1 :')
}

export const HIGHLIGHT_TERMS = [
  'profesionales verificados',
  'perfil de Edify',
  'Edify',
  'publicar una obra',
  'publicar tu obra',
  'obras disponibles',
  'ofertas de trabajo',
  'oferta de trabajo',
  'servicio/producto',
  'cotizaciones',
  'presupuestos',
  'propuestas',
  'documentación',
  'oportunidades',
  'tu perfil',
  'servicios',
  'servicio',
  'obras',
  'obra',
  'producto',
  'materiales',
  'comparar',
  'explorar',
  'sección'
]

export const hasListFormat = (text: string): boolean => {
  return text.includes('•') || text.includes('\n•') || text.includes('\n-')
}

export const parseGuideContent = (content: string) => {
  const firstStepMatch = content.match(/Paso\s*1\s*:/)

  if (!firstStepMatch) {
    return { intro: content, steps: [], outro: '', partialStep: '' }
  }

  const introEndIndex = content.indexOf(firstStepMatch[0])
  const intro = content.substring(0, introEndIndex).trim()

  const stepsSection = content.substring(introEndIndex)
  const steps: string[] = []
  let partialStep = ''
  let outro = ''

  const lastQuestionIndex = stepsSection.lastIndexOf('¿')
  const stepsOnlySection = lastQuestionIndex > 0
    ? stepsSection.substring(0, lastQuestionIndex)
    : stepsSection

  if (lastQuestionIndex > 0) {
    outro = stepsSection.substring(lastQuestionIndex).trim()
  }

  const stepParts = stepsOnlySection.split(/(?=Paso\s*\d+\s*:)/)

  stepParts.forEach((part, index) => {
    if (part.match(/^Paso\s*\d+\s*:/)) {
      const isLastPart = index === stepParts.length - 1

      const stepContent = part.replace(/^Paso\s*\d+\s*:/, '').trim()
      const hasNewlineAfterContent = part.includes('\n') && stepContent.length > 0
      const isFollowedByNextStep = !isLastPart && stepParts[index + 1]?.match(/^Paso\s*\d+\s*:/)

      if (isFollowedByNextStep || (hasNewlineAfterContent && !isLastPart)) {
        steps.push(part.trim().replace(/\n+/g, ' '))
      } else if (isLastPart) {
        partialStep = part.trim()
      }
    }
  })

  return { intro, steps, outro, partialStep }
}
